import { EditOutlined } from '@ant-design/icons';
import React from 'react';
import { Form, Input } from 'antd';
import { PLACEHOLDERS_COPY, TAG_DESCRIPTION } from '@sonar-software/sonar-ts-constants';
const lengthRule = {
    max: TAG_DESCRIPTION.MAX_LENGTH,
    message: TAG_DESCRIPTION.MAX_MESSAGE,
    type: 'string'
};
const rules = [lengthRule];
export const TagDescriptionInput = ({ disabled, name }) => React.createElement(Form.Item, { className: 'tag-description-input', name: name, rules: rules },
    React.createElement(Input, { disabled: disabled, placeholder: PLACEHOLDERS_COPY.TAG_DESCRIPTION, prefix: disabled ? undefined : React.createElement(EditOutlined, null), type: 'text' }));
